export const imgUrl = 'https://d25pmatdh7r1ck.cloudfront.net';
export const url = import.meta.env.VITE_BASE_URL;
export const editorUrl = import.meta.env.VITE_ADSIGN_EDITOR_URL;

